const SPEED_PRESETS = [0.75, 1.0, 1.25, 1.5, 1.75, 2.0];

interface SpeedPillProps {
  speed: number;
  onSpeedChange: (next: number) => void;
}

/** Playback-speed cycling pill — click steps through SPEED_PRESETS and wraps
 *  back to the first. Extracted from ChatMessage.tsx (pure move, byte-
 *  identical behavior) so the Writing Room's chapter reader strip (read-aloud
 *  slice 1) can share it instead of forking a second copy. */
export function SpeedPill({ speed, onSpeedChange }: SpeedPillProps) {
  function handleClick() {
    const idx = SPEED_PRESETS.indexOf(speed);
    const next = SPEED_PRESETS[(idx + 1) % SPEED_PRESETS.length];
    onSpeedChange(next ?? SPEED_PRESETS[0]);
  }

  const label = `${speed}×`;

  return (
    <>
      <button
        className="speed-pill"
        onClick={handleClick}
        title={`Playback speed: ${label}. Click to cycle.`}
        aria-label={`Playback speed ${label}. Click to change.`}
      >
        {label}
      </button>
      <span className="sr-only" aria-live="polite" aria-atomic="true">
        Playback speed {label}
      </span>
    </>
  );
}
